var _path, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFolderNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.76,124.61V30.08H102.61l-7.38-9H-.89V203.64H114.18a72,72,0,1,0,108.58-79Zm-13.1-81.28V57H124.72L113.49,43.33ZM12.23,190.39v-156H89.11l29.48,35.9h91.07v47.67A71.95,71.95,0,0,0,111.72,185c0,1.8.09,3.59.22,5.36ZM183.71,242a57,57,0,1,1,57-57A57.05,57.05,0,0,1,183.71,242Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "191.68 177.03 191.68 146.66 175.74 146.66 175.74 177.03 145.37 177.03 145.37 192.81 175.74 192.81 175.74 223.4 191.68 223.4 191.68 192.81 222.04 192.81 222.04 177.03 191.68 177.03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolderNew);
export default __webpack_public_path__ + "static/media/icon-folder-new.0436c20e.svg";
export { ForwardRef as ReactComponent };